import jsPDF from "jspdf";

export function generateVisitorPacket(facility, t) {
  const doc = new jsPDF({ unit: "pt", format: "letter" });
  const margin = 48;
  const width = doc.internal.pageSize.getWidth();
  let y = margin;

  // Header
  doc.setFillColor(15, 23, 42);
  doc.rect(0, 0, width, 72, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.text("VISITOR PACKET", margin, 32);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text("US Prisoner & Institution Status Portal", margin, 50);
  doc.setTextColor(15, 23, 42);
  y = 100;

  const section = (title) => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(15, 23, 42);
    doc.text(title.toUpperCase(), margin, y);
    y += 6;
    doc.setDrawColor(226, 232, 240);
    doc.setLineWidth(1);
    doc.line(margin, y, width - margin, y);
    y += 14;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
  };

  const row = (label, value) => {
    if (value === undefined || value === null || value === "") return;
    doc.setFont("helvetica", "bold");
    doc.setTextColor(71, 85, 105);
    doc.setFontSize(9);
    doc.text(label.toUpperCase(), margin, y);
    y += 12;
    doc.setFont("helvetica", "normal");
    doc.setTextColor(15, 23, 42);
    doc.setFontSize(11);
    const lines = doc.splitTextToSize(String(value), width - margin * 2);
    doc.text(lines, margin, y);
    y += lines.length * 14 + 10;
    if (y > 720) { doc.addPage(); y = margin; }
  };

  // Facility
  section(t("facility.institutionInfo"));
  row(t("results.system"), facility.system);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text(facility.name, margin, y);
  y += 20;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  row(t("results.ciAddress"), `${facility.address}\n${facility.city}, ${facility.state} ${facility.zip_code}`);
  row(t("facility.phone"), facility.phone);
  row(t("facility.officialWebsite"), facility.website);

  // Status
  section(t("facility.currentStatus"));
  const statusLabel = t(`status.${facility.status}`);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.setTextColor(185, 28, 28);
  doc.text(statusLabel, margin, y);
  y += 20;
  doc.setTextColor(15, 23, 42);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  if (facility.status_note) row("", facility.status_note);
  row(t("facility.lastUpdated"), facility.status_updated_at ? new Date(facility.status_updated_at).toLocaleString() : "—");
  row(t("facility.statusSource"), facility.status_source);
  row(t("facility.officialSource"), facility.status_source_url);

  // Visitation
  section(t("facility.visitationStatus"));
  row(t("facility.visitationStatus"), facility.visitation_status);
  row(t("facility.visitationDays"), facility.visiting_days);
  row(t("facility.visitationHours"), facility.visiting_hours);
  row(t("facility.visitationPhone"), facility.visitation_phone);
  row(t("facility.idRequirements"), facility.visitor_id_requirements);
  row(t("facility.visitationRules"), facility.visitation_rules);

  // Warning footer
  if (y > 640) { doc.addPage(); y = margin; }
  doc.setFillColor(254, 226, 226);
  doc.rect(margin, y, width - margin * 2, 72, "F");
  doc.setTextColor(127, 29, 29);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text(t("facility.beforeYouTravel"), margin + 12, y + 20);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  const warning = `${t("facility.beforeTravelLine1")} ${t("facility.beforeTravelLine2")}`;
  const warnLines = doc.splitTextToSize(warning, width - margin * 2 - 24);
  doc.text(warnLines, margin + 12, y + 38);
  y += 90;

  // Download
  const safeName = (facility.name || "facility").replace(/[^a-z0-9]+/gi, "-").toLowerCase();
  doc.save(`visitor-packet-${safeName}.pdf`);
}
